// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._XW9p0coVTk47eBf6P7W {
  background-color: red;
  position: relative;
  display: flex;
}
._XW9p0coVTk47eBf6P7W > .Te_pHGbLOa3eBJTDGVzz {
  width: 640px;
  height: 640px;
}
._XW9p0coVTk47eBf6P7W .Qdc_xyKNJjFiO47EYErg {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  animation: Oyoc6aEhOOLhdyll1TCQ 2s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 64px;
  font-weight: bold;
  flex-direction: column;
}
._XW9p0coVTk47eBf6P7W .Qdc_xyKNJjFiO47EYErg.K0CDLWdKNiO3UvR5Qeh5 {
  background-color: red;
}
._XW9p0coVTk47eBf6P7W .Qdc_xyKNJjFiO47EYErg.u2UC3_Ipw_Tuqk7Gejui {
  background-color: purple;
  color: white;
}
._XW9p0coVTk47eBf6P7W .Qdc_xyKNJjFiO47EYErg .yr6zqAHnmZdIcn_rG_vh {
  font-size: 32px;
  margin-top: 16px;
  color: white;
  cursor: pointer;
}
._XW9p0coVTk47eBf6P7W .Qdc_xyKNJjFiO47EYErg .yr6zqAHnmZdIcn_rG_vh:hover {
  color: grey;
}

@keyframes Oyoc6aEhOOLhdyll1TCQ {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/Root.sass"],"names":[],"mappings":"AAAA;EACC,qBAAA;EACA,kBAAA;EACA,aAAA;AACD;AACC;EACC,YAAA;EACA,aAAA;AACF;AACC;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AACF;AACE;EACC,qBAAA;AACH;AAAE;EACC,wBAAA;EACA,YAAA;AAEH;AAAE;EACC,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAEH;AADG;EACC,WAAA;AAGJ;;AADA;EACC;IACC,UAAA;EAIA;EAHD;IACC,UAAA;EAKA;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `_XW9p0coVTk47eBf6P7W`,
	"game": `Te_pHGbLOa3eBJTDGVzz`,
	"gameOver": `Qdc_xyKNJjFiO47EYErg`,
	"fadein": `Oyoc6aEhOOLhdyll1TCQ`,
	"lost": `K0CDLWdKNiO3UvR5Qeh5`,
	"won": `u2UC3_Ipw_Tuqk7Gejui`,
	"restart": `yr6zqAHnmZdIcn_rG_vh`
};
export default ___CSS_LOADER_EXPORT___;
